<template>
  <el-dialog
    title="提示"
    :visible.sync="visible"
    width="400px"
  >
    <div class="prompt_box">
      <p v-for="(item,index) in list" :key="index">
        {{item}}
      </p>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name:"promtBox",
  props:{
    list:{
      type:Array,
      default:()=>[]
    }
  },
  data(){
    return {
      visible:false
    }
  }
}
</script>
<style lang="scss" scoped>
.prompt_box{
  overflow-y:auto;
  max-height:400px;
  box-sizing: border-box;
  p{
    display: block;
    color:#FE5252;
    text-align: left;
    padding: 10px;
    border-bottom: 1px solid #eee;
  }
}
</style>